import { OrderRouteItem } from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';

import { NavLink } from 'react-router-dom';

import seagullColoredLogo from '../../../assets/logos/seagull/seagull-colored.svg';
import { GroupedNavItems, NavItemType } from './types.ts';
import { HeaderNavItem } from './HeaderNavItem.tsx';

type GroupedDesktopTopNavItem = {
  route: OrderRouteItem;
  item: NavItemType;
};

export const HeaderDesktopTopNav = ({
  groupedDesktopTopNavItems,
  getRoute,
}: {
  groupedDesktopTopNavItems: GroupedNavItems<GroupedDesktopTopNavItem>[];
  getRoute: (item: NavItemType) => string;
}) => (
  <ul className="main-header-nav">
    {groupedDesktopTopNavItems.map((group) => {
      const firstItem = group.items[0];
      if (group.label === 'APPRAISIFY' && firstItem) {
        return (
          <li key={`header-group-${group.label}`}>
            <NavLink to={getRoute(firstItem.item)} className="main-header-nav-brand-link">
              <img
                src={seagullColoredLogo}
                alt="Appraisify"
                className="main-header-nav-brand-logo"
                width={30}
                height={30}
              />
              <Typography variant="h2" color="textPrimary">
                Appraisify
              </Typography>
            </NavLink>
          </li>
        );
      }
      return (
        <li key={`header-group-${group.label}`}>
          <Typography
            variant="label"
            color="textWarning"
            __dangerDoNotUseSx={{ textTransform: 'uppercase', fontSize: '42px' }}
          >
            yo
          </Typography>
          <Flex>
            {group.items.map(({ item }) => (
              <HeaderNavItem key={item.route} item={item} to={getRoute(item)} />
            ))}
          </Flex>
        </li>
      );
    })}
  </ul>
);
